import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'srcReact/components/common2/Button'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import { isEmpty } from 'srcReact/helpers/validator'
import { appConstantSettings } from 'srcReact/appConstantSettings'

import styles from './styles.module.scss'

const range = (min, max) => [...Array(max - min + 1).keys()].map((i) => i + min)

const Information = ({ updateStep, previousStep, setPreviousStep, goToPreviousStep, formState, setFormState }) => {
  const { t } = useTranslation()

  const [gender, setGender] = useState(formState.gender ? formState.gender : null)
  const [day, setDay] = useState(formState.dayBirth)
  const [month, setMonth] = useState(formState.monthBirth)
  const [year, setYear] = useState(formState.yearBirth)
  const [showError, setShowError] = useState(false)
  const [genderError, setGenderError] = useState('')
  const [dobError, setDobError] = useState('')

  const leapyear = (year1) => {
    const isLeapYear = year1 % 100 === 0 ? year1 % 400 === 0 : year1 % 4 === 0
    return isLeapYear
  }

  const [genderOptions] = useState([
    { label: t('signup.information_module.woman'), value: 'woman' },
    { label: t('signup.information_module.man'), value: 'man' },
    { label: t('signup.information_module.nonconforming'), value: 'nonconforming' }
  ])
  const months = [
    { value: 1, label: t('global.monthsFull.jan'), maxDays: 31 },
    { value: 2, label: t('global.monthsFull.feb'), maxDays: leapyear(year) || year === null ? 29 : 28 },
    { value: 3, label: t('global.monthsFull.mar'), maxDays: 31 },
    { value: 4, label: t('global.monthsFull.apr'), maxDays: 30 },
    { value: 5, label: t('global.monthsFull.may'), maxDays: 31 },
    { value: 6, label: t('global.monthsFull.jun'), maxDays: 30 },
    { value: 7, label: t('global.monthsFull.jul'), maxDays: 31 },
    { value: 8, label: t('global.monthsFull.aug'), maxDays: 31 },
    { value: 9, label: t('global.monthsFull.sep'), maxDays: 30 },
    { value: 10, label: t('global.monthsFull.oct'), maxDays: 31 },
    { value: 11, label: t('global.monthsFull.nov'), maxDays: 30 },
    { value: 12, label: t('global.monthsFull.dec'), maxDays: 31 }
  ].map((e) => ({ ...e }))

  const years = range(1900, 2010)
    .reverse()
    .map((e) => ({ value: e, label: e }))

  const days = range(1, month && month.maxDays ? months && months[month.value - 1].maxDays : 31).map((e) => ({
    value: e,
    label: e
  }))

  const validate = () => {
    setGenderError('')
    setDobError('')
    const allValuesForVerification = [gender, day, month, year].filter((e) => !!e && !isEmpty(e))

    if (allValuesForVerification.length !== 4) {
      setShowError(true)
      if (isEmpty(gender)) {
        setGenderError(t('signup.information_module.error_msg_1'))
        return false
      }
      if (!day) {
        setDobError(t('signup.information_module.error_msg_2'))
        return false
      }
      if (!month.value) {
        setDobError(t('signup.information_module.error_msg_3'))
        return false
      }
      if (!year) {
        setDobError(t('signup.information_module.error_msg_4'))
        return false
      }
    }
    if (getAge(`${year}-${month.value}-${day}`) < appConstantSettings.MINIMUM_AGE) {
      setShowError(true)
      setDobError(t('signup.information_module.error_msg_5'))
      return false
    }
    setShowError(false)
    return true
  }

  const getAge = (birthDateString) => {
    let currentDate = new Date()
    let birthDate = new Date(birthDateString)
    let age = currentDate.getFullYear() - birthDate.getFullYear()
    if (
      currentDate.getMonth() < birthDate.getMonth() ||
      (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())
    ) {
      age--
    }
    return age
  }

  return (
    <div className={styles.container}>
      <div className={styles.container1}>
        <div className={styles.container2}>
          <div className={styles.row}>
            <div className={styles.text1}>{t('signup.information_module.gender_title')}</div>
            <Dropdown1
              className={styles.genderSelectedItem}
              options={genderOptions}
              placeholder={t('signup.information_module.gender')}
              value={gender}
              onChange={(e) => setGender(e)}
            />
            {showError && genderError && <ErrorMessage text={genderError} className={styles.errorMessage} />}
          </div>
          <div className={styles.row}>
            <div className={styles.text2}>{t('signup.information_module.dob?')}</div>
            <div className={styles.dateContainer}>
              <Dropdown1
                className={styles.selectedItemDate}
                options={days}
                placeholder={t('signup.information_module.day')}
                onChange={(e) => setDay(e.value)}
                value={day ? days.filter((x) => x.value == day) : null}
              />
              <Dropdown1
                customDropdownWrapper={styles.wrapperItemDateMonth}
                className={styles.selectedItemDateMonth}
                options={months}
                placeholder={t('signup.information_module.month')}
                onChange={(e) => setMonth(e)}
                value={month.value ? months.filter((x) => x.value == month.value) : null}
              />
              <Dropdown1
                className={styles.selectedItemDateYear}
                options={years}
                placeholder={t('signup.information_module.year')}
                onChange={(e) => setYear(e.value)}
                value={year ? years.filter((x) => x.value == year) : null}
              />
            </div>
          </div>
          {showError && dobError && <ErrorMessage text={dobError} className={styles.errorMessage} />}
        </div>
      </div>

      <div className={styles.buttonContainer}>
        <Button
          text={t('signup.information_module.back')}
          size='large'
          style='secondary'
          handleClick={goToPreviousStep}
        />
        <Button
          text={t('signup.information_module.confirm')}
          size='large'
          customStyle={styles.confirmButton}
          handleClick={() => {
            if (validate()) {
              setPreviousStep([...previousStep, 'information'])
              updateStep('interest')

              setFormState({
                ...formState,
                gender: gender,
                dayBirth: day,
                monthBirth: month,
                yearBirth: year
              })
            }
          }}
        />
      </div>
    </div>
  )
}

export default Information
